export default __webpack_public_path__ + "static/media/doctorportal.daaedb78.PNG";